import * as React from "react";
import { Box, Grid, Pagination, PaginationItem } from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function DuringCard({ data, parent }: any) {
    const [more, setMore] = React.useState(false);
    const click = () => {
        more === true ?
            setMore(false) : setMore(true)
    }
    return (
        <Box >
            <Grid container  >
                <Grid container xs={12}
                    className="headerHistoryList">
                    <Grid item xs={0.5} md={0.5} style={{ maxWidth: '50px', textAlign: 'center' }}>
                        {
                            parent === "GetInProgressOrders" ? <PendingIcon style={{ color: '#FF9100' }} /> :
                                parent === "GetCanceledOrders" ? <CancelIcon style={{ color: '#E6123D' }} /> :
                                    parent === "GetDeliveredOrders" ? <CheckCircleIcon style={{ color: '#01AF43', maxWidth: '50px' }} />
                                        : ""
                        }

                    </Grid>
                    <Grid item xs={11} md={11} >
                        <Grid container style={{ paddingBottom: '10px' }} >
                            <Grid item md={4} xl={3} lg={3} sm={6} xs={12}>
                                {/* xs={2.5} */}
                                <span className="colorTitle">
                                    کد پیگیری سفارش:
                                </span>
                                <span className="colorBase fontWeight">
                                    &nbsp;&nbsp;{data?.trackingCode}
                                </span>
                            </Grid>
                            <Grid item md={4} xl={3} lg={3} sm={6} xs={12}>
                                <span className="colorTitle">
                                    تاریخ ثبت سفارش:
                                </span>
                                <span className="colorBase fontWeight">
                                    &nbsp;&nbsp;{data?.registerDate_Persian}
                                </span>
                            </Grid>
                            <Grid item md={4} xl={2.8} lg={2.5} sm={6} xs={12}>
                                <span className="colorTitle">
                                    مبلغ نهایی:
                                </span>
                                <span className="colorBase fontWeight">
                                    &nbsp;&nbsp;{data?.finalAmount.toLocaleString()} ریال
                                </span>
                            </Grid>
                            <Grid item md={4} xl={3} lg={3} sm={6} xs={12}>
                                <span className="colorTitle">
                                    تاریخ تحویل:
                                </span>
                                <span className="colorBase fontWeight">
                                    &nbsp;&nbsp;{data?.deliveryDate_Persian}
                                </span>
                            </Grid>

                        </Grid>
                    </Grid>

                    {
                        more === true ?
                            <>
                                <Grid container xs={11.5} >
                                    <Grid item xs={0.5} md={0.5} style={{ textAlign: 'center' }}>
                                    </Grid>
                                    <Grid item xs={11.5}>
                                        <Grid container xs={12} style={{ paddingBottom: '16px' }}>
                                            <Grid item md={4} xl={3} lg={3} sm={6} xs={12}>
                                                <span className="colorTitle">
                                                    نام تحویل گیرنده:
                                                </span>
                                                <span className="colorBase fontWeight">
                                                    &nbsp;&nbsp;{data?.recipientName}
                                                </span>
                                            </Grid>
                                            <Grid item md={4} xl={3} lg={3} sm={6} xs={12}>
                                                <span className="colorTitle">
                                                    شماره تماس:
                                                </span>
                                                <span className="colorBase fontWeight">
                                                    &nbsp;&nbsp;{data?.recipientPhone}
                                                </span>
                                            </Grid>
                                            <Grid item md={3.5} xl={3} lg={3} sm={6} xs={12}>
                                                <span className="colorTitle">
                                                    کدپستی:
                                                </span>
                                                <span className="colorBase fontWeight">
                                                    &nbsp;&nbsp;{data?.recipientPostalCode}
                                                </span>
                                            </Grid>

                                        </Grid>
                                        <Grid item xs={12} style={{ paddingBottom: '16px' }} >
                                            <span className="colorTitle">
                                                آدرس:
                                            </span>
                                            <span className="colorBase fontWeight">
                                                &nbsp;&nbsp;{data?.deliveryAddress}
                                            </span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                            : ""
                    }
                    <Grid item xs={0.5} md={0.5} xl={0.2} lg={0.2} style={{ textAlign: 'center', alignSelf: 'center' }}>

                        <span onClick={click}>
                            {
                                more ?
                                    <ExpandLessIcon style={{ color: '#757575', cursor: 'pointer' }} />
                                    :
                                    <ExpandMoreIcon style={{ color: '#757575', cursor: 'pointer' }} />
                            }
                        </span>
                    </Grid>
                </Grid>
                {
                    !data.insufficientInventory ?
                        <Grid item xs={12} className="duringHint">
                            <WarningAmberIcon style={{ color: '#827717', marginRight: '20px' }} />
                            <span style={{ color: '#827717' }}>&nbsp; موجودی این کالا تمام شد.</span>
                        </Grid> : <></>
                }

                <Grid item xs={12}>
                    <div className="orderStateTitle menu-text"
                        style={data.orderState === "WaitForFinalizeByCustomer" || data.orderState === "WaitForSellerApprove" ?
                            { backgroundColor: '#0A58CA' } :
                            data.orderState === "WaitForDelivery" ? { backgroundColor: '#198754' } :
                                data.orderState === "DeliveredToCustomer" ? { backgroundColor: '#198754' } :
                                    data.orderState === "CanceledByCustomer"
                                        ? { backgroundColor: '#FD7E14' } : data.orderState === "CanceledBySeller " ?
                                            { backgroundColor: '#B02A37' } : {}}  >{data?.orderStateTitle}</div>
                </Grid>
                <Grid container xs={12} style={{ marginTop: '15px', height: 'fit-content', marginRight: '30px' }}>
                    <Grid item xl={1.5} lg={2} style={{ justifyContent: 'end' }}>

                        <Grid item xs={12} className="cartImg" >
                            <img
                                style={{ width: '80px', height: '80px' }}
                                className='classCenter'
                                src={`images/Mobile.png`}
                                alt="طرح انتخابی"
                            />
                        </Grid>
                        <Grid item xs={12} className="cartCount" style={{ marginTop: '10px', display: ' grid' }}>
                            <span className="colorTitle textFont12 fontWeight"> تعداد : {data?.count}</span>
                        </Grid>
                    </Grid>
                    <Grid item xl={10.5} lg={10}>
                        <Grid container xs={12}>
                            <Grid item xl={10} lg={10} style={{ paddingTop: ' 10px' }}>
                                <Grid item xs={12} >
                                    <span className="fontWeight">{data?.title}</span>
                                </Grid>
                                {
                                    data?.colorCode ?
                                        <Grid item xs={12} style={{ marginTop: '15px', alignItems: 'center', display: 'flex' }}>
                                            <span className="duringDot"
                                                style={{ backgroundColor: data?.colorCode }}>
                                            </span>
                                            <span className="fontMedium" style={{ marginRight: '10px', font: '12px' }}>{data?.colorTitle}</span>
                                        </Grid> : ""
                                }
                                {
                                    data?.guarantyDescription ?
                                        <Grid item xs={12} style={{ marginTop: '15px' }}>
                                            <span style={{ color: '#1D4A87' }}><GppGoodOutlinedIcon /></span>
                                            <span className="colorTitle textFont12 fontMedium" style={{ marginRight: '10px' }}>
                                                {data?.guarantyDescription}
                                            </span>
                                        </Grid> : ""
                                }
                                {
                                    data?.orderState === "WaitForFinalizeByCustomer" && parent === "GetInProgressOrders" ?
                                        <Grid item xs={12} style={{ marginTop: '15px' }}>
                                            <span style={{ color: '#F06292' }}><AutoAwesomeIcon /></span>
                                            <span className="fontMedium" style={{ marginRight: '10px', color: '#F06292' }}>مهلت تایید نهایی درخواست: {data?.expirationDate_Persian}</span>
                                        </Grid> : ""
                                }

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );
}


